module.exports = __webpack_public_path__ + "static/media/item_1_3_comp.dc5fe59d.png";